import { Component } from '@angular/core';

@Component({
  selector: 'app-home-pymes',
  templateUrl: './home-pymes.component.html'
})
export class HomePymesComponent {
}
